"use strict";
/**
 * ID
 * metadata
 * publicID
 * type
 * subTypes
 * course
 * requiredCredentials
 * arrangements
 * institutionIdentifier
 * customAttributes
 *
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.buildArticulationRefined = void 0;
const ArrangementRefined_1 = require("../Arrangement/ArrangementRefined");
const buildArticulationRefined = (articulation, arrangements) => {
    return {
        ID: articulation.ID,
        metadata: {
            created: articulation.metadata.created,
            updated: articulation.metadata.updated,
        },
        publicID: articulation.publicID,
        type: articulation.type,
        subTypes: articulation.subTypes,
        course: { ID: articulation.course.ID },
        requiredCredentials: articulation.requiredCredentials,
        arrangements: arrangements.map((arrangement) => (0, ArrangementRefined_1.buildArrangementRefined)(arrangement)),
        institutionIdentifier: articulation.institutionIdentifier,
        customAttributes: articulation.customAttributes,
        files: articulation.files,
        links: articulation.links,
    };
};
exports.buildArticulationRefined = buildArticulationRefined;
//# sourceMappingURL=ArticulationRefined.js.map